module.exports = __webpack_public_path__ + "img/tarjeta_servicios_subsidio_paralizacion.35aefe5f.jpg";